import React, { Component } from 'react';
import { Table } from 'semantic-ui-react'
import axios from 'axios'
import createBrowserHistory from 'history/createBrowserHistory';
import LargeProjectsNav from './LargeProjectsNav';
import {  getSalesPeopleDropDown } from './LargeProjectUtils'
import { firebaseAuth, pythonApiIp, toCurrency } from '../../../../config/constants'
import { checkAdminEmail } from '../algoliaDashboard/AlgoliaMiscUtils';
import { getProjectList } from './ApiUtils'
import { Link } from 'react-router-dom';
import {CommObjectUi} from './UiUtils'

const history = createBrowserHistory({ forceRefresh: true });

class ViewDeliveredUnpaid extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            salesPeopleChoices:[],
            showCommissionButton:false,
            showUnpaidButoon:false,
            projects:[],
            commObject:'',
            loading:false
         }
    }


    componentDidMount(){
        // if(this.props.match.params.filter){
        //     console.log("fillx1 filter is there loading sales people")
        //     getSalesPeople(this.loadSalesPeople);
        // }

        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            // console.log("addx24 +++++++++:firebaseAuth().onAuthStateChanged");

            if (user) {
                console.log("addx241 user is:" + user.email);
                // let isAnonymous = user.isAnonymous;
                // let uid = user.uid;

                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult)

                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })

            }
        })
        
    }

    setAdminResult = (returnObject) => {
        console.log("++++++ addx294 setAdminResult");
        console.log("filltx1 returnObject:" + JSON.stringify(returnObject, null, 3));
        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
        })

        if (returnObject.algoliaUser.viewAllCommission) {
            console.log("filltx12 algoliaUser.viewAllCommission is true")
            this.setState({showCommissionButton:true, showUnpaidButoon:true})
            this.getProjectListUnPaid();
        } else {
            console.log("filltx13 algoliaUser.viewAllCommission is FALSE, user not alloed to view commission")
        }
    }

    loadProjectList = (projects) => {
      //  console.log("gpx12 ++++++++:loadProjectList");

        if (projects && projects.length > 0) {
            this.setState({
                projects: projects
            })
        } else {
            alert("unable to load projects")
        }
    }

    getProjectListUnPaid = () => {
        console.log("filltx15 ++++++++:getProjectList");

        this.setState({ loading: true })

        axios.post(pythonApiIp + 'getProjectList', {
            apiKey: "asdfasdf",
            filter: "delNotPaid"
        })
            .then((response) => {

                console.log("filltx16 results:" + JSON.stringify(response.data, null, 3));
                console.log("filltx164 results:" + JSON.stringify(response.data.commObject, null, 3));
                console.log("filltx165 results:" + response.data.commObject.numProject);

                // let test = JSON.parse(response.data.commObject);
                // console.log("filltx166 results:" + test.numProject);

                if (response.data.result) {
                    console.log("filltx17 got results");

                    this.setState({
                        loading: false,
                        projects: response.data.projects,
                        commObject: response.data.commObject,
                    }, console.log("filltx161 commObject:" + JSON.stringify(this.state.commObject, null, 3)))

                } else {
                    console.log("FAILED");
                    this.setState({ loading: false })
                    alert(response.data.message);
                }
            })
            .catch((error) => {
                console.log("extt1:" + error);
                alert("Unable to load ext121")
                this.setState({ loading: false })
            });
    }


    // loadSalesPeople = (salesPeople) => {
    //     console.log("gts1 ++++++++:loadSalesPeopleDropdown");
    //     console.log("gtc15:"+JSON.stringify(salesPeople,null,3));
    //     if(salesPeople && salesPeople.length > 0){
    //         console.log("gtc15 customer dropdown...")
    //         this.setState({
    //             salesPeopleChoices: getSalesPeopleDropDown(salesPeople)
    //         })
    //     }else{
    //         alert("unable to load customers")
    //     }
    // }

    enterNewCustomer = () => {
        history.push("/dashboard/enterLargeCustomer");
    }

    enterNewProject = () => {
        history.push("/dashboard/enterLargeProject");
    }


    // enterProjectCosts = () => {
    //     history.push("/dashboard/enterProjectCosts");
    // }

    home = () => {
        history.push("/dashboard/largeProjectsHome");
    }

    //this.props.match.params.artist

    handleDropDownChanges = (value) => {
        console.log("lst1 handleDropDownChanges");
        console.log('lst12 You\'ve sss:', value);
        console.log("lst13 category alone:" + value.category);
        console.log('lst14 You\'ve selected:', value.value + " " + value.category);
        console.log("lst15 -  this.props.itemSelected:" + this.state.itemSelected);
        console.log("lst16 - array index:" + this.props.arrayIndex);

        let newState = {};
        newState[value.category] = value.value;
        console.log("newState 1:" + JSON.stringify(newState, null, 3));

        //this.setState(newState);
        this.setState(newState);
    }
    
    render() { 

        const commObjectUi = this.state.commObject != ''
        ? <CommObjectUi commObject = {this.state.commObject} />
        :''

        const rows = this.state.projects.length > 0
        ? this.state.projects.map((item) =>
            <Table.Row>
                <Table.Cell> {item.idlargeprojects} </Table.Cell>
                <Table.Cell> {item.name} </Table.Cell>
                <Table.Cell> {item.datedelivered} </Table.Cell>
                <Table.Cell> {item.expectedpaymentdate} </Table.Cell>
                <Table.Cell> {toCurrency(item.totalpayment)} </Table.Cell>
                
                <Table.Cell> {item.paymentstatus}</Table.Cell>
                <Table.Cell> {item.salesperson.name}</Table.Cell>
                <Table.Cell> <Link to={'/dashboard/viewLargeProject/' + item.idlargeprojects}>EDIT</Link></Table.Cell>
            </Table.Row>)
        : ''

        return ( 
            <div>
                <LargeProjectsNav showCommissionButton={this.state.showCommissionButton} 
                        showUnpaidButoon={this.state.showUnpaidButoon}/>
                <br/>
                {/* {salesPeopleDropDown} */}
                <div>
                    {commObjectUi}
                <h2>PROJECTS</h2>
                <Table celled>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>Id</Table.HeaderCell>
                            <Table.HeaderCell>Project</Table.HeaderCell>
                            <Table.HeaderCell>Date Del</Table.HeaderCell>
                            <Table.HeaderCell>Payment Date</Table.HeaderCell>
                            <Table.HeaderCell>Total Cost</Table.HeaderCell>
                            
                            <Table.HeaderCell>PAID</Table.HeaderCell>
                            <Table.HeaderCell>SALES PERSON</Table.HeaderCell>
                            <Table.HeaderCell>EDIT</Table.HeaderCell>
                        
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {rows}
                    </Table.Body>
                </Table>
            </div>
            </div>
         );
    }
}
 
export default ViewDeliveredUnpaid;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/LargeProjects/ViewDeliveredUnpaid.js